const Loading = () => {
  return (
    <div className="loading-animation">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Loading;
